import { dateOrNull } from "../../utils";

interface AddOnPermissionProps {
	id: string;
	key: string;
	ceratedAt: Date | null;
	identifier: AddOnPermissionIdentifier;
	status: AddOnPermissionStatus;
}

type AddOnPermissionJson = {
	id: string;
	key: string;
	cerated_at?: string | null;
	identifier: { type: AddOnPermissionType; value: string };
	status: AddOnPermissionStatus;
};

class AddOnPermission {
	constructor(public _: AddOnPermissionProps) {}

	static fromJson(json: AddOnPermissionJson) {
		return new AddOnPermission({
			id: json.id,
			key: json.key,
			ceratedAt: dateOrNull(json.cerated_at),
			identifier: AddOnPermissionIdentifier.fromJson(json.identifier),
			status: json.status,
		});
	}

	toJson() {
		return {
			id: this._.id,
			key: this._.key,
			cerated_at: this._.ceratedAt,
			identifier: this._.identifier.toJson(),
			status: this._.status,
		};
	}
}

interface AddOnPermissionIdentifierProps {
	type: AddOnPermissionType;
	value: string;
}

class AddOnPermissionIdentifier {
	constructor(public _: AddOnPermissionIdentifierProps) {}

	static fromJson(json: { type: AddOnPermissionType; value: string }) {
		return new AddOnPermissionIdentifier({
			type: json.type,
			value: json.value,
		});
	}

	toJson() {
		return {
			type: this._.type,
			value: this._.value,
		};
	}

	equals(other: AddOnPermissionIdentifier) {
		return this._.type === other._.type && this._.value === other._.value;
	}
}

enum AddOnPermissionType {
	AIRTABLE_ACCOUNT = "airtable_account",
	AIRTABLE_ACCOUNT_INVITE = "airtable_account_invite",
	AIRTABLE_BASE = "airtable_base",
	AIRTABLE_SHARED = "airtable_shared",
}

enum AddOnPermissionStatus {
	ACTIVE = "active",
	INACTIVE = "inactive",
}

type AddOnPermissionTypeDetailsProps = {
	type: AddOnPermissionType;
	displayName: string;
	color: string;
	icon: string;
};

class AddOnPermissionTypeDetails {
	constructor(public _: AddOnPermissionTypeDetailsProps) {}

	static fromType(type: AddOnPermissionType) {
		switch (type) {
			case AddOnPermissionType.AIRTABLE_ACCOUNT:
				return new AddOnPermissionTypeDetails({
					type,
					displayName: "Airtable Account",
					color: "blue",
					icon: "user",
				});
			case AddOnPermissionType.AIRTABLE_ACCOUNT_INVITE:
				return new AddOnPermissionTypeDetails({
					type,
					displayName: "Airtable Account Invite",
					color: "blue",
					icon: "user",
				});
			case AddOnPermissionType.AIRTABLE_BASE:
				return new AddOnPermissionTypeDetails({
					type,
					displayName: "Airtable Base",
					color: "green",
					icon: "database",
				});
			case AddOnPermissionType.AIRTABLE_SHARED:
				return new AddOnPermissionTypeDetails({
					type,
					displayName: "Shared Base",
					color: "red",
					icon: "key",
				});
		}
	}
}

export {
	AddOnPermission,
	AddOnPermissionIdentifier,
	AddOnPermissionType,
	AddOnPermissionStatus,
	AddOnPermissionTypeDetails,
};
